import { useDispatch, useSelector } from "react-redux";
import { useState } from "react";
import { toast } from "react-toastify";

import { Modal } from "../../../common/Atoms/Modal";
import { env } from "../../../common/lib/env";
import { RootState } from "../../store";
import { setState } from "../../slices/statementPreviewModal";
import { useApiRequest } from "../../hooks/useApiRequest";

import { StatementPreviewPanel } from "./StatementPreviewPanel";

export function StatementPreview() {
  const dispatch = useDispatch();
  const [downloading, setDownloading] = useState(false);
  const request = useApiRequest();
  const modalState = useSelector((s: RootState) => s.statementPreviewModal);

  function close() {
    dispatch(setState({ show: false, html: null }));
  }

  async function onDownload() {
    if (downloading) return;
    setDownloading(true);

    try {
      const result = await request({
        method: `GET`,
        responseType: `blob`,
        url: `${env.baseApiUrl}organisation/previewStatementPdf`,
      });

      const url = window.URL.createObjectURL(new Blob([result.data]));
      const link = document.createElement(`a`);
      link.href = url;
      link.setAttribute(`download`, `test_statement_outstanding.pdf`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
    catch (e) {
      const responseObj = await e.response?.data?.text();
      toast.error(`${responseObj ? `${responseObj}` : `Could not create statement.`}`);
    }

    setDownloading(false);
  }

  return (
    <Modal
      title={ `Statement Preview` }
      open={ !!modalState.show }
      setOpen={ close }
      width={ `xl` }
    >
      <StatementPreviewPanel
        html={ modalState.html }
        showDownloadNotice
        downloading={ downloading }
        onDownload={ onDownload }
      />
    </Modal>
  );
}
